// extracted by mini-css-extract-plugin
export default {"myLinkify":"_2Yyr","opponentLinkify":"_2orE","italic":"_4pnR"};